var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.href)?_c('a',{attrs:{"href":_vm.href,"target":_vm.target},on:{"click":_vm.handleClick}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }